"use client";

import { Card, CardContent, cn } from "@saridana-core/react-ui-kit";
import { CareersCollection, TCareerItem, TCareerSection } from "@shared/types";
import Image from "next/image";
import Link from "next/link";

export function CareerSection({ title, description, items }: TCareerSection) {
  return (
    <section className="py-20 sm:py-[100px] lg:py-[120px] bg-white">
      <div className="container relative">
        <h1 className="text-5xl sm:text-6xl font-bold mb-6 sm:mb-7">{title || "Career"}</h1>
        {description && <p className="text-xl text-gray-700 mb-12 sm:mb-[60px]">{description}</p>}

        {items &&
          items?.length > 0 &&
          items?.map((val: { title: string; careers: CareersCollection }, index: number) => (
            <div key={`career-item-${index}`} className="mb-12 sm:mb-20">
              <h3 className="text-base sm:text-xl font-bold tracking-widest mb-6">{val.title || "Career"}</h3>
              {val?.careers?.data && val?.careers?.data?.length > 0 && <CareerCards careers={val?.careers?.data} />}
            </div>
          ))}
      </div>
    </section>
  );
}

export function CareerCards({
  careers,
}: {
  careers: {
    id: number;
    attributes: TCareerItem;
  }[];
}) {
  return (
    <div className={cn("relative grid grid-cols-1", `md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6`)}>
      {careers?.map((item: { id: number; attributes: TCareerItem }) => (
        <Card key={`career-card-${item.id}`} className="relative rounded-2xl min-h-[30rem] overflow-hidden p-0">
          <CardContent className="p-0">
            {item?.attributes?.image?.data?.attributes?.url && (
              <Image
                className="w-full min-h-[448px] sm:min-h-[476px] lg:min-h-[548px] flex-shrink-0 object-cover object-contains absolute z-1"
                src={item?.attributes?.image?.data?.attributes?.url}
                height={item?.attributes?.image?.data?.attributes?.height}
                width={item?.attributes?.image?.data?.attributes?.width}
                alt={
                  item?.attributes?.image?.data?.attributes?.alternativeText ||
                  item?.attributes?.image?.data?.attributes?.name ||
                  "Career About Item Section"
                }
              />
            )}
            <div
              className="absolute z-2 h-full w-full"
              style={{
                background:
                  "linear-gradient(0deg, rgba(12, 50, 69, 0.05), rgba(12, 50, 69, 0.05)),linear-gradient(180deg, rgba(12, 50, 69, 0) 56%, #0C3245 79.51%)",
              }}
            ></div>
            <div className="text-white absolute z-2 bottom-0 w-full p-6">
              {item?.attributes?.internalLink?.href || item?.attributes?.externalLink?.href ? (
                <Link
                  href={
                    item?.attributes?.useLink === "internalLink"
                      ? item?.attributes?.internalLink?.href
                      : item?.attributes?.externalLink?.href
                  }
                  target={
                    item?.attributes?.useLink === "internalLink"
                      ? item?.attributes?.internalLink?.target
                      : item?.attributes?.externalLink?.target
                  }
                >
                  <h6 className="font-bold text-2xl  lg:text-[28px] mb-2 hover:text-primary">{item?.attributes?.title}</h6>
                </Link>
              ) : (
                <h6 className="font-bold text-2xl  lg:text-[28px] mb-2">{item?.attributes?.title}</h6>
              )}

              <p className="text-lg sm:text-xl">
                {item?.attributes?.location} • {item?.attributes?.type}
              </p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
